import React from "react"
import { navigate } from "gatsby"
import Nav from "../nav"

import Tin from "../../images/tin-registration.svg"

const TinCorrection = () => {
  return (
    <div style={{ background: "#F8F8F8" }}>
      <div className="nav-wrapper bg__sparkle--black">
        <div className="container">
          <Nav />
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="sparkle--title sparkle-deep-blue my-5">
              TIN Correction
            </h2>
            <div className="business-suport-card p-lg-5 p-3 my-5">
              <div className="intro">
                <h5 className="font-weight-bold mb-5">
                  {" "}
                  <img
                    src={Tin}
                    alt="TIN Correction"
                    className="img-fluid mr-4"
                    width="70"
                  />{" "}
                  TIN Correction
                </h5>

                <div className="ml-lg-4">
                  <ul className="list-styled ml-lg-5 pl-lg-5">
                    <li>
                      Have a registered business or company and RC
                      number
                    </li>
                    <li>
                      Update your valid email address and phone number of the
                      business
                    </li>
                    <li>
                      A copy of your Certificate of registration document.
                    </li>
                    <li>
                      This service cost{" "}
                      {/* <span className="style-1">
                        <del>
                          <span className="amount font-weight-normal">₦4,000</span>
                        </del>
                        <ins>
                          <span className="amount">₦3,500</span>
                        </ins>
                      </span> */}
                      <span>₦ 6,000.00</span> if you already have a Sparkle
                      Personal account.
                    </li>
                         <li>
                     Timeline: 4-5 working days after name approval and receipt of complete required documents and information. 
                    </li>
                  </ul>
                </div>

                <div className="row justify-content-center">
                  <div className="col-lg-4">
                    <div className="text-center my-5">
                      <button
                        className="btn sparkle--button__green px-5 mt-4 btn-block"
                        onClick={() =>
                          navigate("/business-support/verify", {
                            state: {
                              service: "TIN Correction",
                              path: "/business-support/tin-correction/start",
                            },
                          })
                        }
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TinCorrection
